import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { IDispatcherListResponseData } from '../../models/dispatcher/dispatcherList.model';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../models/https';
import { dispatcherActions } from '../../redux/slices/dispatcherSlice';
import { useAppDisPatch } from '../../redux/store';
import useHttps from '../useHttps';

const useDispatcherList = () => {
  const dispatch = useAppDisPatch();
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const setDispatcherListError = (err: AxiosError<ErrorHttpResponse>) => {
    // console.log('Med os');
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while geting dispatchers list'
    );
  };

  const setDispatcherList = ({
    data,
  }: SuccessHttpResponse<IDispatcherListResponseData>) => {
    dispatch(dispatcherActions.setDispatcher({ dispatcherList: data.records }));
  };

  const getDispatcherList = () => {
    const url: HttpConfig = {
      url: 'authentication-service/v1/dispatchers?page=0&size=1000000000',
      method: 'get',
    };

    request(url, setDispatcherList, setLoading, setDispatcherListError);
  };

  return { getDispatcherList, loading };
};

export default useDispatcherList;
